(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"] && !Shopify.designMode) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 50))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            const initializedEnhancements = {
              swatches: false,
              variants: false,
              tooltips: false,
              compare: false
            };
            const initRecommendationEnhancements = () => {
              if (!initializedEnhancements.swatches) {
                if (typeof window.initSwatchOptionImage === 'function') {
                  window.initSwatchOptionImage();
                  initializedEnhancements.swatches = true;
                }
              }
              if (!initializedEnhancements.variants) {
                if (typeof window.initVariantChanger === 'function') {
                  window.initVariantChanger(this);
                  initializedEnhancements.variants = true;
                }
              }
              if (!initializedEnhancements.tooltips) {
                if (typeof window.initTooltips === 'function') {
                  window.initTooltips([].slice.call(this.querySelectorAll('[data-bs-toggle="tooltip"]')));
                  initializedEnhancements.tooltips = true;
                }
              }
              if (!initializedEnhancements.compare) {
                if (typeof window.initCompare === 'function') {
                  window.initCompare();
                  initializedEnhancements.compare = true;
                }
              }
              return initializedEnhancements.swatches
                && initializedEnhancements.variants
                && initializedEnhancements.tooltips
                && initializedEnhancements.compare;
            };
            if (!initRecommendationEnhancements()) {
              const mainScript = document.querySelector('script[src*="main.min.js"], script[delay*="main.min.js"], script[src*="main.js"], script[delay*="main.js"]');
              if (mainScript) {
                mainScript.addEventListener('load', () => {
                  window.setTimeout(initRecommendationEnhancements, 250);
                }, { once: true });
              }
              window.setTimeout(initRecommendationEnhancements, 500);
              window.setTimeout(initRecommendationEnhancements, 4500);
            }
            const initRecommendationSlider = () => {
              if (!this.querySelector('.swiper-wrapper')) return true;
              if (typeof window.Swiper !== 'function') {
                return false;
              }
              const slideroptionConfig = JSON.parse(this.dataset.sliderOptions || '{}');
              if (this.swiper && typeof this.swiper.destroy === 'function') {
                this.swiper.destroy(true, false);
              }
              new window.Swiper(this, slideroptionConfig);
              return true;
            };
            if (!initRecommendationSlider()) {
              const swiperScript = document.querySelector('script[src*="swiper.js"]');
              if (swiperScript) {
                swiperScript.addEventListener('load', initRecommendationSlider, { once: true });
              }
              window.setTimeout(initRecommendationSlider, 500);
            }
            if (window.jQuery && typeof $.getScript === 'function') {
              $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/embed/loader.js");
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
